import React from 'react';
import { RenderRichTextData } from 'gatsby-source-contentful/rich-text';

import RichTextSection from 'components/CaseStudyPage/RichTextSection';

export interface IRichTextContainer {
  content: {
    backgroundColor: string;
    slug: string;
    richTextBody: RenderRichTextData<any>;
  };
}

export const RichTextContainer: React.FC<IRichTextContainer> = ({
  content,
}) => {
  if (!content) {
    return null;
  }
  const { richTextBody, slug, backgroundColor } = content;

  return (
    <RichTextSection
      backgroundColor={backgroundColor}
      slug={slug}
      richText={richTextBody}
    />
  );
};

export default RichTextContainer;
